import {observable} from 'mobx';
import {construct, ModelProperties} from '../utils';

export class OfferProductPrice {
    @observable id!: number;

    @observable productId!: number;

    @observable productCode!: string;

    @observable price!: number;

    @observable currency!: string;

    @observable updatedAt!: Date;

    @observable default!: number;

    constructor(productPrice?: ModelProperties<OfferProductPrice>) {
        if (productPrice) {
            construct(this, productPrice);
        }
    }
}
